(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Poison-quiz"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-poison-quiz]').forEach(function(root){
    var configEl = root.querySelector('[data-quiz-config]');
    if(!configEl) return;

    var config;
    try{
      config = JSON.parse(configEl.textContent);
    }catch(e){
      console.error('Poison quiz: could not parse config', e);
      var mount = root.querySelector('[data-questions-mount]');
      if(mount){
        mount.innerHTML = '<p style="color:#e2554a;font-size:13px;">Quiz config error — check that every question and result block is fully filled in. (' + e.message + ')</p>';
      }
      return;
    }

    var questions = config.questions || [];
    var results = config.results || {};
    var current = 0;
    var scores = {};

    var progressEl = root.querySelector('[data-progress]');
    var mountEl = root.querySelector('[data-questions-mount]');
    var resultEl = root.querySelector('[data-result]');
    var bgEl = root.querySelector('[data-bg]');
    var retakeBtn = root.querySelector('[data-retake]');

    // Build one progress bar segment per question
    progressEl.innerHTML = questions.map(function(){
      return '<span><i></i></span>';
    }).join('');
    var bars = progressEl.querySelectorAll('span > i');

    function renderQuestion(){
      var q = questions[current];
      if(!q) return;
      mountEl.innerHTML = '<p class="poison-quiz__qtext">' + q.text + '</p>' +
        '<div class="poison-quiz__options">' +
        q.options.map(function(o, i){
          return '<button class="poison-quiz__opt" type="button" data-answer="' + i + '">' +
            o.label +
            (o.tag ? '<span class="poison-quiz__opt-tag">' + o.tag + '</span>' : '') +
            '</button>';
        }).join('') +
        '</div>';

      mountEl.querySelectorAll('[data-answer]').forEach(function(btn){
        btn.addEventListener('click', function(){
          answer(parseInt(btn.getAttribute('data-answer'), 10));
        });
      });

      bars.forEach(function(bar, i){
        bar.style.width = i < current ? '100%' : '0%';
      });
    }

    function answer(i){
      var choice = questions[current].options[i];
      scores[choice.line] = (scores[choice.line] || 0) + 1;
      bars[current].style.width = '100%';
      current++;
      if(current < questions.length){
        renderQuestion();
      }else{
        showResult();
      }
    }

    function showResult(){
      mountEl.style.display = 'none';

      var winner = null;
      var best = -1;
      Object.keys(scores).forEach(function(key){
        if(scores[key] > best){ best = scores[key]; winner = key; }
      });
      if(!winner){ winner = Object.keys(results)[0]; }

      var r = results[winner];
      if(!r) return;

      root.querySelector('[data-result-badge]').textContent = 'Your line: ' + r.name;
      root.querySelector('[data-result-name]').textContent = r.name;
      root.querySelector('[data-result-desc]').textContent = r.description;
      root.querySelector('[data-result-cta]').href = r.cta;

      var logo = root.querySelector('[data-result-logo]');
      logo.src = r.logo;
      logo.alt = r.name + ' logo';

      if(r.graphic){
        bgEl.style.backgroundImage = 'url(' + r.graphic + ')';
        bgEl.classList.add('is-visible');
      }

      resultEl.classList.add('is-visible');
    }

    function restart(){
      current = 0;
      scores = {};
      resultEl.classList.remove('is-visible');
      bgEl.classList.remove('is-visible');
      mountEl.style.display = 'block';
      bars.forEach(function(bar){ bar.style.width = '0%'; });
      renderQuestion();
    }

    if(retakeBtn){
      retakeBtn.addEventListener('click', restart);
    }

    renderQuestion();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reasons-comparison"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-reasons-comparison]').forEach(function(root){
    var tabs = root.querySelectorAll('[data-rc-tab]');
    var panels = root.querySelectorAll('[data-rc-panel]');

    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        var idx = tab.getAttribute('data-rc-tab');

        tabs.forEach(function(t){ t.classList.remove('is-active'); });
        tab.classList.add('is-active');

        panels.forEach(function(p){
          p.classList.toggle('is-active', p.getAttribute('data-rc-panel') === idx);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
